import axios from 'axios';
import { getStoredTokens, refreshSession } from '../services/authService';

// Create an axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_LUNA_URL, // Make sure this matches your backend URL
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const { accessToken } = getStoredTokens();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiry
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config || {};
    const status = error?.response?.status;

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await refreshSession();
        const { accessToken } = getStoredTokens();
        if (accessToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers['Authorization'] = 'Bearer ' + accessToken;
        }
        return api(originalRequest);
      } catch (refreshError) {
        // Leave tokens as-is to avoid flapping if backend is momentarily unavailable
        return Promise.reject(refreshError);
      }
    }

    // For 403 or other errors, do not auto-logout here. Let caller decide.
    return Promise.reject(error);
  }
);

export default api; 